export { PendientesAnalisis, PendientesValidacion, HistorialSolicitudes } from "./pages/Solicitudes";

export { AnalisisDRC, ValidacionDRC, DetalleDRC } from "./pages/DetalleSolicitud";


